import { useEffect } from "react"

export const useBrowserPrompt = (block: boolean) => {
    useEffect(() => {
        if(!block) {
            return;
        }

        const confirmExit = (e: BeforeUnloadEvent) => {
            e.preventDefault();
            return e.returnValue = "The form contains unsaved changes. If you leave, you will loose those chnages. Do you want to continue?";
        }

        window.addEventListener('beforeunload', confirmExit);

        return function () {
            window.removeEventListener('beforeunload', confirmExit);
        }

    }, [block])

}